import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AssignGetexRegulationParagraphsRequirementsMutationVariables = Types.Exact<{
  input: Types.AssignGetexRegulationParagraphsRequirementsInput;
}>;


export type AssignGetexRegulationParagraphsRequirementsMutation = { __typename?: 'Mutation', assignGetexRegulationParagraphsRequirements: { __typename?: 'AssignGetexRegulationParagraphsRequirementsPayload', getexRegulation?: { __typename?: 'GetexRegulation', id: string } | null } };


export const AssignGetexRegulationParagraphsRequirementsDocument = gql`
    mutation AssignGetexRegulationParagraphsRequirements($input: AssignGetexRegulationParagraphsRequirementsInput!) {
  assignGetexRegulationParagraphsRequirements(input: $input) {
    getexRegulation {
      id
    }
  }
}
    `;
export type AssignGetexRegulationParagraphsRequirementsMutationFn = Apollo.MutationFunction<AssignGetexRegulationParagraphsRequirementsMutation, AssignGetexRegulationParagraphsRequirementsMutationVariables>;

/**
 * __useAssignGetexRegulationParagraphsRequirementsMutation__
 *
 * To run a mutation, you first call `useAssignGetexRegulationParagraphsRequirementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignGetexRegulationParagraphsRequirementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignGetexRegulationParagraphsRequirementsMutation, { data, loading, error }] = useAssignGetexRegulationParagraphsRequirementsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignGetexRegulationParagraphsRequirementsMutation(baseOptions?: Apollo.MutationHookOptions<AssignGetexRegulationParagraphsRequirementsMutation, AssignGetexRegulationParagraphsRequirementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignGetexRegulationParagraphsRequirementsMutation, AssignGetexRegulationParagraphsRequirementsMutationVariables>(AssignGetexRegulationParagraphsRequirementsDocument, options);
      }
export type AssignGetexRegulationParagraphsRequirementsMutationHookResult = ReturnType<typeof useAssignGetexRegulationParagraphsRequirementsMutation>;
export type AssignGetexRegulationParagraphsRequirementsMutationResult = Apollo.MutationResult<AssignGetexRegulationParagraphsRequirementsMutation>;
export type AssignGetexRegulationParagraphsRequirementsMutationOptions = Apollo.BaseMutationOptions<AssignGetexRegulationParagraphsRequirementsMutation, AssignGetexRegulationParagraphsRequirementsMutationVariables>;